import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import React from 'react';
import { Row } from './Row';
import { jsx as _jsx } from "react/jsx-runtime";
export function DocRow(docProps) {
  return /*#__PURE__*/_jsx(Row, _objectSpread({}, docProps));
}
// #sourceMappingURL=DocRow.js.map